import type { ICreatePasswordLocale } from '../../../../../Pages/Onboard/CreatePassword/Locale/CreatePassword.locale';

const esES: ICreatePasswordLocale = {
  title: 'Crea tu contraseña de {brand}',
  subtitle: 'Tu contraseña debe cumplir con los requisitos de seguridad a continuación.',
  password: {
    label: 'Nueva Contraseña',
    placeholder: 'Ingresa tu nueva contraseña',
    error: 'La contraseña debe cumplir todos los requisitos',
  },
  confirmPassword: {
    label: 'Confirmar Contraseña',
    placeholder: 'Confirma tu nueva contraseña',
    error: 'Por favor, confirma tu contraseña',
    mismatchError: 'Las contraseñas no coinciden',
  },
  button: {
    createPassword: 'Crear Contraseña',
    creatingPassword: 'Creando Contraseña...',
    backToLogin: 'Volver al Login',
  },
  success: {
    title: '¡Contraseña creada exitosamente!',
    message: 'Tu contraseña ha sido creada. Ahora puedes iniciar sesión en tu cuenta.',
  },
  requirements: {
    title: 'Requisitos de la Contraseña:',
    minLength: 'Al menos 8 caracteres',
    uppercase: 'Una letra mayúscula',
    lowercase: 'Una letra minúscula',
    number: 'Un número',
    specialChar: 'Un carácter especial',
  },
};

export { esES };
